(function () {
  'use strict';

  const Naturiva = {
    cart: null,
    routes: window.Shopify && window.Shopify.routes ? window.Shopify.routes : { root: '/' },
  };

  const cartState = {
    async fetch() {
      const res = await fetch(`${Naturiva.routes.root}cart.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) throw new Error('cart fetch failed');
      Naturiva.cart = await res.json();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: Naturiva.cart } }));
      return Naturiva.cart;
    },
    async add({ id, quantity = 1 }) {
      const res = await fetch(`${Naturiva.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id, quantity }),
      });
      if (!res.ok) {
        const msg = await res.json().catch(() => ({ description: 'No se pudo agregar al carrito' }));
        throw new Error(msg.description || 'No se pudo agregar al carrito');
      }
      return cartState.fetch();
    },
    async change({ key, quantity }) {
      const res = await fetch(`${Naturiva.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      if (!res.ok) throw new Error('cart change failed');
      return cartState.fetch();
    },
  };

  function formatMoney(cents) {
    const amount = (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return `$${amount} MXN`;
  }

  function showToast(message) {
    const toast = document.createElement('div');
    toast.setAttribute('role', 'alert');
    toast.className = 'toast';
    toast.textContent = message;
    document.body.appendChild(toast);
    requestAnimationFrame(() => toast.classList.add('toast--visible'));
    setTimeout(() => {
      toast.classList.remove('toast--visible');
      setTimeout(() => toast.remove(), 300);
    }, 4000);
  }

  // ---------- Gallery (product page) ----------
  function initGallery(root) {
    const main = root.querySelector('[data-main-media]');
    const thumbs = root.querySelectorAll('[data-gallery-thumbs] button');
    if (!main || thumbs.length === 0) return;
    thumbs.forEach((btn) => {
      btn.addEventListener('click', () => {
        const src = btn.dataset.mediaSrc;
        const srcset = btn.dataset.mediaSrcset;
        const alt = btn.dataset.mediaAlt || '';
        if (src) main.src = src;
        if (srcset) main.srcset = srcset;
        main.alt = alt;
        thumbs.forEach((t) => t.removeAttribute('aria-current'));
        btn.setAttribute('aria-current', 'true');
      });
    });
  }

  // ---------- Variant selector ----------
  function initVariantSelector(form) {
    const dataEl = document.querySelector('[data-product-json]');
    if (!dataEl) return;
    let product;
    try {
      product = JSON.parse(dataEl.textContent);
    } catch (_) {
      return;
    }
    const variantInput = form.querySelector('[data-variant-id]');
    const priceEl = form.querySelector('[data-price]');
    const button = form.querySelector('[data-add-to-cart]');
    const soldOutLabel = button && button.dataset.soldOutText ? button.dataset.soldOutText : 'Agotado';
    const addLabel = button && button.dataset.addText ? button.dataset.addText : 'Agregar al carrito';

    function currentOptions() {
      return Array.from(form.querySelectorAll('input[type="radio"][data-option-index]:checked')).reduce((acc, r) => {
        acc[parseInt(r.dataset.optionIndex, 10)] = r.value;
        return acc;
      }, {});
    }

    function matchVariant() {
      const opts = currentOptions();
      return product.variants.find((v) => {
        return (
          (opts[0] === undefined || v.option1 === opts[0]) &&
          (opts[1] === undefined || v.option2 === opts[1]) &&
          (opts[2] === undefined || v.option3 === opts[2])
        );
      });
    }

    function update() {
      const variant = matchVariant();
      if (!variant) {
        if (button) {
          button.disabled = true;
          button.textContent = soldOutLabel;
        }
        return;
      }
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) {
        let html = `<span class="price__amount">${formatMoney(variant.price)}</span>`;
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += ` <s class="price__compare">${formatMoney(variant.compare_at_price)}</s>`;
        }
        priceEl.innerHTML = html;
      }
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? addLabel : soldOutLabel;
      }
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (_) {}
    }

    form.querySelectorAll('input[type="radio"][data-option-index]').forEach((r) => {
      r.addEventListener('change', update);
    });
    update();
  }

  // ---------- Product form (add to cart) ----------
  function initProductForm(form) {
    initVariantSelector(form);
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const button = form.querySelector('[data-add-to-cart]');
      const idInput = form.querySelector('[data-variant-id]');
      if (!idInput) return;
      const id = parseInt(idInput.value, 10);
      const qtyInput = form.querySelector('[data-quantity]');
      const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      if (button) button.disabled = true;
      try {
        await cartState.add({ id, quantity });
        openDrawer();
      } catch (err) {
        document.dispatchEvent(new CustomEvent('cart:error', { detail: { message: err.message } }));
      } finally {
        if (button) button.disabled = false;
      }
    });
  }

  // ---------- Cart drawer ----------
  let drawerOpenedOnce = false;

  function openDrawer() {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    if (!drawerOpenedOnce) {
      cartState.fetch().catch(() => {});
      drawerOpenedOnce = true;
    }
  }

  function closeDrawer() {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }

  function renderDrawer(cart) {
    const list = document.querySelector('[data-cart-items]');
    const subtotal = document.querySelector('[data-cart-subtotal]');
    const empty = document.querySelector('[data-cart-empty]');
    if (!list) return;
    const savings = document.querySelector('[data-cart-savings]');
    const savingsAmt = document.querySelector('[data-cart-savings-amount]');
    if (cart.item_count === 0) {
      list.innerHTML = '';
      if (empty) empty.hidden = false;
      if (subtotal) subtotal.textContent = formatMoney(0);
      if (savings) savings.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    list.innerHTML = cart.items
      .map((item) => {
        const img = item.image ? `<img src="${item.image}" alt="${item.product_title}" width="64" height="64" loading="lazy">` : '';
        const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<small>${item.variant_title}</small>` : '';
        return `
          <li class="cart-drawer__item" data-key="${item.key}">
            ${img}
            <div class="cart-drawer__item-info">
              <a href="${item.url}">${item.product_title}</a>
              ${variant}
              <div class="cart-drawer__qty">
                <button type="button" data-qty-decr aria-label="Disminuir">−</button>
                <span>${item.quantity}</span>
                <button type="button" data-qty-incr aria-label="Aumentar">+</button>
                <button type="button" data-qty-remove aria-label="Quitar">×</button>
              </div>
              <span class="cart-drawer__line-price">${formatMoney(item.final_line_price)}</span>
            </div>
          </li>
        `;
      })
      .join('');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    if (savings) {
      if (cart.total_discount > 0) {
        savings.hidden = false;
        if (savingsAmt) savingsAmt.textContent = formatMoney(cart.total_discount);
      } else {
        savings.hidden = true;
      }
    }
  }

  function updateCartCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      if (cart.item_count > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }

  function initDrawer() {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    const close = drawer.querySelector('[data-cart-close]');
    const backdrop = drawer.querySelector('[data-cart-drawer-backdrop]');
    if (close) close.addEventListener('click', closeDrawer);
    if (backdrop) backdrop.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeDrawer();
    });
    drawer.addEventListener('click', async (e) => {
      const item = e.target.closest('[data-key]');
      if (!item) return;
      const key = item.dataset.key;
      const currentQty = parseInt(item.querySelector('.cart-drawer__qty span').textContent, 10);
      if (e.target.matches('[data-qty-incr]')) {
        await cartState.change({ key, quantity: currentQty + 1 }).catch((err) => document.dispatchEvent(new CustomEvent('cart:error', { detail: { message: err.message } })));
      } else if (e.target.matches('[data-qty-decr]')) {
        await cartState.change({ key, quantity: Math.max(0, currentQty - 1) }).catch((err) => document.dispatchEvent(new CustomEvent('cart:error', { detail: { message: err.message } })));
      } else if (e.target.matches('[data-qty-remove]')) {
        await cartState.change({ key, quantity: 0 }).catch((err) => document.dispatchEvent(new CustomEvent('cart:error', { detail: { message: err.message } })));
      }
    });

    document.querySelectorAll('[data-cart-link]').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        openDrawer();
      });
    });
  }

  // ---------- Cart page quantity changes ----------
  function initCartPage() {
    const page = document.querySelector('[data-cart-page]');
    if (!page) return;
    page.addEventListener('change', async (e) => {
      const input = e.target.closest('[data-cart-qty]');
      if (!input) return;
      const key = input.dataset.key;
      const quantity = parseInt(input.value, 10);
      try {
        const cart = await cartState.change({ key, quantity });
        const line = input.closest('[data-line]');
        const linePrice = cart.items.find((i) => i.key === key);
        if (linePrice && line) {
          const lp = line.querySelector('[data-line-price]');
          if (lp) lp.textContent = formatMoney(linePrice.final_line_price);
        } else if (!linePrice && line) {
          line.remove();
        }
        const subtotalEl = page.querySelector('[data-cart-subtotal]');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
        if (cart.item_count === 0) window.location.reload();
      } catch (err) {
        document.dispatchEvent(new CustomEvent('cart:error', { detail: { message: err.message } }));
      }
    });
  }

  // ---------- Error toast ----------
  document.addEventListener('cart:error', (e) => {
    showToast(e.detail && e.detail.message ? e.detail.message : 'Error');
  });

  document.addEventListener('cart:updated', (e) => {
    const cart = e.detail.cart;
    updateCartCount(cart);
    renderDrawer(cart);
  });

  // ---------- Bootstrap ----------
  function initStickyBuy() {
    const bar = document.querySelector('[data-sticky-buy]');
    if (!bar) return;
    const inlineForm = document.querySelector('.product-page__info [data-product-form]');
    if (!inlineForm || !('IntersectionObserver' in window)) return;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const out = !entry.isIntersecting;
        bar.classList.toggle('is-visible', out);
        bar.setAttribute('aria-hidden', out ? 'false' : 'true');
      });
    }, { threshold: 0, rootMargin: '0px 0px -120px 0px' });
    obs.observe(inlineForm);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-gallery-root]').forEach(initGallery);
    document.querySelectorAll('[data-product-form]').forEach(initProductForm);
    initDrawer();
    initCartPage();
    initStickyBuy();
    cartState.fetch().catch(() => {});
  });
})();
